var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"common-link-submenu",class:{ 'common-link--active': _vm.active },attrs:{"href":_vm.url},on:{"mouseover":_vm.open}},[_vm._v("\n  "+_vm._s(_vm.link.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }